import React from 'react';
import './FeatureCard.css';

export function FeatureCard({ icon: Icon, tag, title, description, isHighlighted, onClick }) {
  return (
    <div
      className={`feature-card ${isHighlighted ? 'feature-card--highlighted' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className="feature-card__header">
        <div className="feature-card__icon-box">
          <Icon size={22} />
        </div>
        {tag && <span className="feature-card__tag">{tag}</span>}
      </div>
      <h3 className="feature-card__title">{title}</h3>
      <p className="feature-card__desc">{description}</p>
    </div>
  );
}
